export function selectOptionQuoteWindow(rows, centerIndex, radius = 8) {
  if (!rows.length) return []
  const center = Math.min(Math.max(Number(centerIndex) || 0, 0), Math.max(0, rows.length - 1))
  return rows.slice(Math.max(0, center - radius), Math.min(rows.length, center + radius + 1))
}
